import styled from 'styled-components'

const colors = {
  primary: '#6a26ca',
  secondary: '#f19d4c',
  whiteColor: '#FFFFFF',
  lightBlack: '#212121',
  Black: '#250F43',
  grey: '#707070',
  purple: '#A58BC9',
}

export const RobotoMedium14 = styled.p`
  margin: 0;
  padding: 0;
  font-family: Roboto;
  font-size: ${(props) => props.fontSize || '14px'};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`
export const P = styled.p`
  width: ${(props) => props.width || 'auto'};
  max-width: ${(props) => props.maxWidth};
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'row'};

  text-align: ${(props) => props.textAlign};

  align-self: ${(props) => props.alignSelf};
  align-items: ${(props) => props.alignItems};
  margin: ${(props) => props.margin};

  overflow-wrap: break-word;

  margin: ${(props) => props.margin};

  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-bottom: ${(props) => props.marginBottom};
  margin-top: ${(props) => props.marginTop};

  opacity: ${(props) => props.opacity};

  line-height: ${(props) => props.lineHeight};

  height: ${(props) => props.height};
  color: ${(props) => props.color};
  text-align: ${(props) => props.textAlign};
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  font-family: nudista-web, sans-serif;
  font-style: ${(props) => props.fontStyle || 'normal'};

  background-image: ${(props) => props.backgroundImage};
  background-color: ${(props) => props.backgroundColor};
`

export const HelveticaNeueRegular14 = styled.p`
  font-family: HelveticaNeue;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`
export const HelveticaNeueBold14 = styled.p`
  font-family: HelveticaNeue;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaBold12 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaBold14 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaBold16 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`
export const NudistaBoldCustomFont = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: ${(props) => props.fontSize || '16px'};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  background-color: ${(props) => props.backgroundColor};
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaBold18 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaSemiBold8 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 8px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaSemiBold11 = styled.p`
  margin: ${(props) => props.margin || '0'};
  width: ${(props) => props.width};
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: ${(props) => props.fontSize || '11px'};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaSemiBold12 = styled.p`
  margin: ${(props) => props.margin || '0'};
  width: ${(props) => props.width};
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: ${(props) => props.fontSize || '12px'};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaSemiBold13 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaSemiBold16 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: ${(props) => props.fontSize || '16px'};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.88;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaMedium12 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 12px;
  font-weight: ${(props) => props.fontWeight || '500'};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: inherit;
  opacity: ${(props) => props.opacity};
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaMedium11 = styled.p`
  width: ${(props) => props.width};

  margin: 0;
  margin-left: ${(props) => props.marginLeft};
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: normal;
  text-align: inherit;
  opacity: ${(props) => props.opacity};
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaMedium14 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: ${(props) => props.textAlign || 'inherit'};
  opacity: ${(props) => props.opacity};

  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`
export const NudistaMedium16 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaMedium9 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: ${(props) => props.fontSize || '9px'};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: inherit;
  opacity: ${(props) => props.opacity};
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`

export const NudistaMedium7 = styled.p`
  margin: 0;
  padding: 0;
  font-family: nudista-web, sans-serif;
  font-size: 7px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: inherit;
  color: ${({ color, white }) =>
    color ? colors[color] : white ? '#ffffff' : '#000000'};
`
